import { useEffect, useMemo, useRef } from 'react';
import useAuth from './useAuth';
import { useLoading } from '../context/LoadingProvider';
import { useNotifications } from '../context/NotificationProvider';
import { createApiClient } from '../api/createApiClient';

export default function useApi() {
  const { auth, setAuth } = useAuth();
  const loader = useLoading();
  const notify = useNotifications();
  const accessToken = auth?.accessToken;
  const loaderRef = useRef(loader);
  const notifyRef = useRef(notify);

  useEffect(() => {
    loaderRef.current = loader;
  }, [loader]);

  useEffect(() => {
    notifyRef.current = notify;
  }, [notify]);

  const api = useMemo(() => {
    return createApiClient({
      auth: { accessToken },
      loader: {
        add: (...args) => loaderRef.current.add(...args),
        remove: (...args) => loaderRef.current.remove(...args),
      },
      notify: {
        success: (...args) => notifyRef.current.success(...args),
        error: (...args) => notifyRef.current.error(...args),
      },
      setAuth
    });
  }, [accessToken, setAuth]);

  return api;
}
